import { faTrashAlt, faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Link, ListItem, Text, UserProfileImage,
} from '@domain-group/suit-theme'

import useUser from '@hooks/useUser'

import { confirmDelete } from '@functions/entity'

interface UserListItemProps {
  userId: number,
  callbacks: {
    removeAgentUser: (params: any) => void,
  },
}

const UserListItem = (props: UserListItemProps) => {
  const { userId, callbacks: { removeAgentUser } } = props

  const userPayload = useUser({ id: userId })

  const {
    image,
    user,
    user: {
      email, full_name,
    },
  } = userPayload

  const confirmDeletePayload = {
    callbacks: { deleteFn: () => removeAgentUser(user.actable_id) },
    strings: { deleteString: 'remove', entityName: 'Agent' },
  }

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        justifyContent: 'space-between',
        paddingY: 'large',
      }}
      disableHover
    >
      <UserProfileImage
        // @ts-expect-error TS2339
        imageUrl={image?.thumb_url}
        height={40}
        width={40}
      >
        <FontAwesomeIcon icon={faUser} />
      </UserProfileImage>

      <Box flexDirection="column" marginLeft="medium">
        <Text color="bodyFontColor" fontSize="small">
          {full_name}
        </Text>

        <Text variant="ellipsis" marginTop="small" color="mysteryGrey" fontSize="xsmall">
          {email}
        </Text>
      </Box>

      <Box justifyContent="flex-end" alignItems="center" color="faintGrey" fontSize="small">
        <Link
          greyLink
          // @ts-expect-error TS2322
          marginLeft="medium"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </Link>
      </Box>
    </ListItem>
  )
}

export default UserListItem
